class HomepageHero {
  constructor(component) {
    this.refs = {
      video: '.js-video',
      playPauseButton: '.js-play-pause-button',
      playIcon: '.js-play-icon',
      pauseIcon: '.js-pause-icon',
    };

    this.dom = {
      $component: component,
      $video: component.querySelector(this.refs.video),
      $playPauseButton: component.querySelector(this.refs.playPauseButton),
      $playIcon: component.querySelector(this.refs.playIcon),
      $pauseIcon: component.querySelector(this.refs.pauseIcon),
    };

    this.state = {
      innerWidth: null,
      view: null,
    };

    this.init();

    this.mount();
  }


  init() {
    this.setView();
    this.setVideoSrc();
  }

  mount() {
    const { dom } = this;

    if (!dom.$video) return;

    dom.$video.addEventListener('loadeddata', () => {
      dom.$video.play();
    });

    window.addEventListener('resize', this.handleResize.bind(this));

    dom.$playPauseButton.addEventListener('click', this.togglePlayPause.bind(this));
    
  }

  togglePlayPause() {
    const { dom } = this;
    
    if (dom.$video.paused) {
      dom.$video.play();
      dom.$playIcon.classList.add('hidden');
      dom.$pauseIcon.classList.remove('hidden');
    } else {
      dom.$video.pause();
      dom.$playIcon.classList.remove('hidden');
      dom.$pauseIcon.classList.add('hidden');
      
    }
  }

  handleResize() {
    const { dom, state } = this;
    if (state.innerWidth === window.innerWidth) return;

    state.innerWidth = window.innerWidth;

    if (!dom.$video) return;

    if (state.innerWidth < 768 && state.view !== 'mobile') {
      console.log('Mobile view - change src ');
      this.setView();
      this.setVideoSrc();
      return;
    }

    if (state.innerWidth >= 768 && state.innerWidth < 1024 && state.view !== 'tablet') {
      console.log('Tablet view - change src ');
      this.setView();
      this.setVideoSrc();
      return;
    }

    if (state.innerWidth >= 1024 && state.view !== 'desktop') {
      console.log('Desktop view - change src ');
      this.setView();
      this.setVideoSrc();
      return;
    }
  }

  setVideoSrc() {
    const { dom, state } = this;
    
    dom.$video.src = dom.$video.getAttribute(`data-${state.view}-src`);
    dom.$video.play();
  }

  setView() {
    const { state } = this;

    state.innerWidth = window.innerWidth;
    
    if (state.innerWidth < 768) {
      state.view = 'mobile';
      return;
    }

    if (state.innerWidth >= 768 && state.innerWidth < 1024) {
      state.view = 'tablet';
      return;
    }
    
    state.view = 'desktop';
  }
}

const $homepageHero = document.querySelector('.js-homepage-hero');
if ($homepageHero) new HomepageHero($homepageHero);